var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_not_found"},[_vm._v("잘못된 접근입니다.")])}
var staticRenderFns = []

export { render, staticRenderFns }